import GoogleMap from "./Map";

export default GoogleMap;